import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServiceService } from '../service.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-factory-projection-create',
  templateUrl: './factory-projection-create.component.html',
  styleUrls: ['./factory-projection-create.component.css']
})
export class FactoryProjectionCreateComponent implements OnInit {
      factoryCreationForm: FormGroup;
      disable =true
  constructor(
    private formBuilder: FormBuilder,
    private apiService :ServiceService,
    private router: Router
  ) {
    this.factoryCreationForm = this.formBuilder.group({
      year_month: ["", Validators.required],
      created_by_id: [null,Validators.required],
      material_id: [null, Validators.required],
      material_name: ['', Validators.required],
      uom: ['', Validators.required],
      in_liter: [0, Validators.required],
      approved_quantity: [0, Validators.required],
      per_can_qty_in_kg: [0],
      intermediate_material_id: [null],
      total_req_intermediate: [0],
    });
    // date

    const date = new Date();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensures two digits
    const year = date.getFullYear();
    const nowdate = `${year}-${month}`;
    this.factoryCreationForm.patchValue({
      year_month: nowdate,
    })
   }

  ngOnInit(): void {
    this.materialDropdown()
    this.IntermediateDropdown()
    // this.factoryCreationForm.get('uom')?.disable();

    try {
      var created_id: any
      created_id = localStorage.getItem('admin_id')
      this.factoryCreationForm.patchValue({
        created_by_id: created_id,
      })
    } catch (error) {
      alert("User Id not found")
    }
  }
  MaterialDropdown:any=[]
  intermediateDropdown:any=[]
  materialDropdown(){
    this.apiService.ProductDropdown().subscribe((res)=>{
      console.log(res)
      this.MaterialDropdown = res.data
    })
  }
  IntermediateDropdown(){
    this.apiService.interProductMatch('').subscribe((res)=>{
      console.log('inter',res)
      this.intermediateDropdown = res.data
    })
  }

  product(value:any){
    console.log(value);
    this.factoryCreationForm.patchValue({
      material_name: value.product_name,
      uom: value.product_uom_main
    })
    console.log(this.factoryCreationForm.value); 
  }

  calculations(){
    console.log(this.factoryCreationForm.get('approved_quantity')?.value);
    
    var ap_qty = this.factoryCreationForm.get('approved_quantity')?.value
    var qty_kg = this.factoryCreationForm.get('per_can_qty_in_kg')?.value
    this.factoryCreationForm.patchValue({
      total_req_intermediate: ap_qty * qty_kg,
    })
    
  }

  submit() {
    if(this.factoryCreationForm.invalid){
      this.factoryCreationForm.markAllAsTouched()
    }
    else{
      this.apiService.factoryProjectionCreate(this.factoryCreationForm.value).subscribe((res)=>{
        console.log("res",res)
        if(res.success){
          this.router.navigate(['admin/factory-projection-listing']);
          this.apiService.showToast('success', 'successfully added')
        }else{
          this.apiService.showToast('error', res.message)
        }
      })
    }
    }
  

}
